export default "__VITE_ASSET__DRulIiUs__"